<style lang="less" scoped>
@media screen and (max-width: 768px) {
    .top_img{
        width:100%;
        height:2.4rem;
        position: relative;
        img{
            width:auto;
            height: 1.6rem;
            margin:.2rem auto;
            display: block;
        }
        span.logo-day{
            display: block;
            font-size: .2rem;
            position: absolute;
            top: 0.32rem;
            right: 2.45rem;
            z-index: 11;
            text-align: center;
            width: .3rem;
        }
    }
    .content{
        width:6.7rem;
        height:9.8rem;
        padding:1.2rem .4rem 1.38rem;
        margin:0 auto;
        position: relative;
        z-index: 2;
        background:url("../assets/images/login-bg-phone.png") no-repeat;
        background-size: 100% 100%;
        >div{
            height:auto;
        }
    }
    .login_con{
        width:100%;
        padding:.4rem 1rem 0;
        .form_row{
            width:100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: .36rem;
            font-weight: bold;
            line-height: 1;
            margin-bottom: .2rem;

            .form_label{
                width: 1.45rem;
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }
            .form_content{
                width:1.8rem;
                height:.6rem;
                margin-left:.28rem;
                border-bottom: 2px solid #1D2088;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                input{
                    width:100%;
                    font-size: .3rem;
                    font-weight: bold;
                    border:none;
                    outline: none;
                    background:transparent;
                }
            }
        }
    }
    .form_sub{
        width:2.2rem;
        height:.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .36rem;
        font-weight: bold;
        color:#1D2088;
        border:2px solid #1D2088;
        border-radius: .1rem;
        margin:.6rem auto .4rem;
    }
    .info_con{
        width:5.1rem;
        margin: 0 auto;
        position: relative;
        font-size: .24rem;
        color:#333;
        .link{
            font-size: .3rem;
            font-weight: bold;
            color:#F47381;
            position: absolute;
            right:0;
            z-index: 11;
        }
        a{
            color:#333;
        }
        .more{
            color:#F47381;
            font-weight: bold;
            margin-top: .05rem;
        }
    }
    .moreDetail{
        width:100vw;
        height:100vh;
        background:rgba(0,0,0,.5);
        position: fixed;
        top:0;
        left:0;
        z-index: 999;
        .box{
            width:80%;
            height: 80vh;
            margin:10vh auto;
            border-radius: .2rem;
            padding:.4rem;
            background:#fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .title{
                font-size: .4rem;
                font-weight: bold;
                text-align: center;
                margin-bottom: .4rem;
            }
            .desc{
                flex:1;
                font-size: .28rem;
            }
            .close{
                width:2rem;
                height:.8rem;
                border:2px solid #1D2088;
                border-radius: .1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                color:#1D2088;
                font-size: .36rem;
            }
        }
    }
    .info_row{
        height:.36rem;
        line-height: .36rem;
    }
    .apply{
        top: .4rem;
    }
    .notice{
        top: .8rem;
    }
    .boy{
        width:2.5rem;
        height:auto;
        display: block;
        position: absolute;
        right:-.3rem;
        bottom:-2.7rem;
        z-index: 11;
    }
    .bottom_img{
        width:100%;
        height:auto;
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 1;
        // background:url("../assets/images/bg2-phone.png")
        img{
            width:100%;
            height:auto;
            display: block;
        }
    }
    .message{
        width:100%;
        .text{
            width:6.7rem;
            margin:0 auto;
            border: .08rem solid #F8C80E;
            border-radius: .2rem;
            background:#FFFDE4;
            padding: .7rem .6rem 1rem;
            color:#715800;
            font-size: .3rem;
            font-weight: bold;
            white-space: pre-line;
        }
        .closeBtn{
            width:1.2rem;
            height:1.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border: .08rem solid #F8C80E;
            border-radius: 50%;
            background:#fff;
            margin:.2rem auto;
            img{
                width:.45rem;
                height:.45rem;
                display: block;
            }
        }
    }
}
@media screen and (min-width: 769px) {
    .top_img{
        width:100%;
        height:120px;
        position: relative;
        img{
            width:auto;
            height: 80px;
            margin: 20px auto;
            display: block;
        }
        span.logo-day{
            display: block;
            font-size: 12px;
            position: absolute;
            top: 16px;
            right: 106px;
            z-index: 11;
            text-align: center;
            width: 30px;
        }
    }
    .content{
        width:325px;
        height:490px;
        padding:60px 20px 69px;
        margin:0 auto;
        position: relative;
        z-index: 2;
        background:url("../assets/images/login-bg-phone.png") no-repeat;
        background-size: 100% 100%;
        >div{
            height:auto;
        }
    }
    .login_con{
        width:100%;
        padding:20px 50px 0;
        .form_row{
            width:100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            font-weight: bold;
            line-height: 1;
            margin-bottom: 10px;

            .form_label{
                width: 72px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }
            .form_content{
                width:90px;
                height:30px;
                margin-left:14px;
                border-bottom: 2px solid #1D2088;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                input{
                    width:100%;
                    font-size: 14px;
                    font-weight: bold;
                    border:none;
                    outline: none;
                    background:transparent;
                }
            }
        }
    }
    .form_sub{
        width:110px;
        height:40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: bold;
        color:#1D2088;
        border:2px solid #1D2088;
        border-radius: 5px;
        margin:30px auto 20px;
    }
    .info_con{
        width:5.1rem;
        margin: 0 auto;
        position: relative;
        font-size: .24rem;
        color:#333;
        .link{
            font-size: .3rem;
            font-weight: bold;
            color:#F47381;
            position: absolute;
            right:0;
            z-index: 11;
        }
        a{
            color:#333;
        }
        .more{
            color:#F47381;
            font-weight: bold;
            margin-top: .05rem;
        }
    }
    .moreDetail{
        width:100vw;
        height:100vh;
        background:rgba(0,0,0,.5);
        position: fixed;
        top:0;
        left:0;
        z-index: 999;
        .box{
            width:80%;
            height: 80vh;
            margin:10vh auto;
            border-radius: .2rem;
            padding:.4rem;
            background:#fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .title{
                font-size: .4rem;
                font-weight: bold;
                text-align: center;
                margin-bottom: .4rem;
            }
            .desc{
                flex:1;
                font-size: .28rem;
            }
            .close{
                width:2rem;
                height:.8rem;
                border:2px solid #1D2088;
                border-radius: .1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                color:#1D2088;
                font-size: .36rem;
            }
        }
    }
    .info_row{
        height:.36rem;
        line-height: .36rem;
    }
    .apply{
        top: .4rem;
    }
    .notice{
        top: .8rem;
    }
    .boy{
        width:2.5rem;
        height:auto;
        display: block;
        position: absolute;
        right:-.3rem;
        bottom:-2.7rem;
        z-index: 11;
    }
    .bottom_img{
        width:100%;
        height:auto;
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 1;
        // background:url("../assets/images/bg2-phone.png")
        img{
            width:100%;
            height:auto;
            display: block;
        }
    }
}
</style>
<template>
    <div class="page_con">
        <div class="top_img">
            <img src="../assets/images/logo-pc.png" alt="">
            <span class="logo-day">{{date}}</span>
        </div>
        <div class="content">
            <div class="login_con">
                <!-- <form name="LoginForm" method="post" action="http://203.105.32.92/User/login.html">
                    <input type="text" name="txtSchool" id="txtSchool" maxlength="30" value="" class="lgn_input" />
                    <input type="text" name="txtName" id="txtName" maxlength="30" value="" class="lgn_input" />
                    <input type="password" name="txtPswd" id="txtPswd" maxlength="16" value="" class="lgn_input" />
                    <input type="submit" name="BtnSubmit" id="BtnSubmit" value="登錄" class="lgn_button" />
                </form> -->
                <div class="form_row">
                    <div class="form_label">
                        <span>學校編號</span>
                    </div>
                    <div class="form_content">
                        <input v-model="school" type="text">
                    </div>
                </div>
                <div class="form_row">
                    <div class="form_label">
                        <span>用戶編號</span>
                    </div>
                    <div class="form_content">
                        <input v-model="account" type="text">
                    </div>
                </div>
                <div class="form_row">
                    <div class="form_label">
                        <span>用戶密碼</span>
                    </div>
                    <div class="form_content">
                        <input v-model="password" type="password">
                    </div>
                </div>
                <div class="form_sub" @click="login">
                    <div class="btn_blue">登錄</div>
                </div>
            </div>
            <div class="info_con">
                <div class="info_row">Pc及Ipad用户，请使用：<a href="http://kid.e-game123.com">kid.e-game123.com</a></div>
                <div class="info_row">Whatsapp：9389 8914</div>
                <!-- <div class="info_row">傳真：2646 9221</div> -->
                <div class="info_row">電郵：new123education@gmail.com</div>
                <div class="info_row">策劃：何萬貫教授</div>
                <div class="info_row">本學期學習至 ：1月27日</div>
                <div class="more" @click="showMore = true">查看詳情</div>
                <span class="apply link" href="Javascript:;">報名參加</span>
                <a class="notice link" href="http://www.hk-123.com">公告板</a>
                <img src="../assets/images/login-boy-pc.png" alt="" class="boy">
            </div>
        </div>
        <div class="moreDetail" @click="showMore = false" v-show="showMore">
            <div class="box" @click.stop>
                <div class="title">公告詳情</div>
                <div class="desc" v-html="detailHtml"></div>
                <div class="auth"></div>
                <div class="close" @click="showMore = false">確認</div>
            </div>
        </div>
        <div class="bottom_img">
            <img src="../assets/images/bg2-phone.png" alt="">
        </div>
        <!-- <div class="shade" v-if="showMessage">
            <div class="message">
                <div class="text">
                    本計劃於7月10日結束。同仍可以登入稠站神请以前文章

                    同學仍可登入閱讀以前的文章(溫習)。

                    或補讀未閱讀的文章。

                    直至8月5日止



                    又：

                    新學年：

                    2021年9月13日至2022年1月28日  (上學期)
                </div>
                <div class="closeBtn" @click="showMessage = false">
                    <img src="../assets/images/close.png" alt="">
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
export default {
    data(){
        return {
            date:'',
            school:'',
            account:'',
            password:'',
            showMessage:true,
            messageTimer:null,
            showMore:false,

            detailHtml:'' // 用于存储HTML格式的详细内容
        }
    },
    mounted(){
        this.getDay();
        this.loadScriptContent(this);
    },
    methods:{
        async loadScriptContent(vm) {
            const url = '/html.js';
            try {
                const response = await fetch(url);
                const content = await response.text();
                console.log(content);
                vm.detailHtml = content;
            } catch (error) {
                console.error('Error fetching script content:', error);
            }
        },
        closeMessage(){
            this.messageTimer = setTimeout(()=>{
                this.showMessage = false;
            },10000)
        },
        getDay(){
            this.date = new Date().getDate();
        },
        login(){
            // this.$http.post('/User/login.html',{txtSchool:this.school,txtName:this.account,txtPswd:this.password}).then(res=>{
            //     console.log(res)
            // })
            let vm = this;
            this.$http({
                url:this.baseUrl+'/User/login.html',
                params:{
                    txtSchool:this.school,
                    txtName:this.account,
                    txtPswd:this.password,
                    rest_key:1,
                },
                method:'GET',
                headers:{
                    // 'Content-type':'application/x-www-form-urlencoded'
                }
            })
            //console.log(this.school,this.account,this.password);
            //this.$http.get('/User/login.html?txtSchool='+this.school+'&txtName='+this.account+'&txtPswd='+this.password)
            .then(res=>{
                if(res.data.code == 1){
                    // console.log(this.$stroe);
                    // this.$store.commit('setUserInfo',res.data.data.user);
                    vm.$router.push('/index')
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/login.vue